import React from "react";
import "./CategoryRail.css";

export default function CategoryRail({ categories, variant, language, selectedCategory, settings, logo, placeholder, onSelect }) {
  const arabic = language === "arabic";
  const items = settings.hide_categories_layout_all ? categories : [null, ...categories];
  return (
    <nav id="categories_header" className={`sf-category-rail sf-category-rail--${variant}`}
      aria-label={arabic ? "التصنيفات" : "Categories"} dir={arabic ? "rtl" : "ltr"}
      style={{ "--sf-category-accent": settings.dark || "#33475e" }}>
      <div id="categories-top" className="sf-category-rail__scroll">
        {items.map(category => {
          const selected = category ? String(selectedCategory?.id) === String(category.id) : selectedCategory === "all";
          const name = category ? (arabic ? category.ar_name || category.name : category.name) : (arabic ? "الكل" : "All");
          const source = category || categories[0] || {};
          const photo = source.photo_thumb || source.photo_small || source.photo || logo;
          return (
            <button key={category?.id || "all"} id={`header-${category?.id || "all"}`}
              type="button" aria-pressed={selected} className="sf-category-rail__button"
              onClick={() => onSelect(category || "all")}>
              {variant === "bubbles" && <img alt="" draggable={false} src={photo?.startsWith("http") ? photo : placeholder} />}
              <span>{name}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
